import { Tooltip } from 'components/tooltip/Tooltip.tsx';
import { Dropdown } from 'components/dropdown/Dropdown.tsx';
import { Icon } from 'components/atoms/Icon.tsx';
import { cn } from 'utils/cn';

export type Props = {
	className?: string;
	message: string;
	mobileTitle: string;
	placement?: Dropdown.Placement;
};

export function WarningTooltip({ message, mobileTitle, placement, className }: Props) {
	return (
		<Tooltip
			placement={placement}
			mobileTitle={mobileTitle}
			wrapperClassName={cn('absolute right-5 top-1/2 top-[calc(50%_-_10px)]', className)}
			openerContent={<Icon className="text-warning hover:text-warning-hover" fill={true} type="help" size={20} />}
			containerClassName="px-6 pb-8 md:p-4 md:py-2 font-medium text-sm md:text-sm md:w-[250px]"
		>
			{message}
		</Tooltip>
	);
}
